import config from "../config";

export const urlForAsset = path => name =>
  `${config.assetsBaseUrl}/media/${path}/${name}`;
export const urlForMedia = path => `${config.assetsBaseUrl}/media/${path}`;

export const urlForPublishing = urlForAsset("publishing");
export const urlForFeatured = urlForAsset("featured");
export const urlForAbout = urlForAsset("about");
